<router-outlet></router-outlet>
<app-error-500-modal
  [isVisible]="(showError500Modal$ | async) ?? false"
></app-error-500-modal>
<app-global-loader></app-global-loader>
